import {AfterViewInit, Component, Inject, OnInit, ViewChild} from '@angular/core';
import {DIALOG_CONFIG} from 'ac-infra';
import {CustomErrorStateMatcher} from '../../../../utils/custom-error-state-matcher.directive';
import {FormControl, FormGroup, NgForm} from '@angular/forms';
import {confirmPasswordValidator} from '../../../../utils/confirm-password-validator.directive';


@Component({
  selector: 'configurator-credentials-dialog',
  templateUrl: './configurator-credentials-dialog.component.html',
  styleUrls: ['./configurator-credentials-dialog.component.scss']
})
export class ConfiguratorCredentialsDialogComponent implements OnInit, AfterViewInit {

  @ViewChild('mapForm') form: NgForm;

  typeOptionList = [ 'DEVICE', 'ROUTER'];
  data;
  confirmationControl: FormGroup;
  matcher: any;
  isEdit: boolean;

  constructor(@Inject(DIALOG_CONFIG) private dialogConfig) { }

  ngOnInit(): void {

    this.matcher = new CustomErrorStateMatcher();

    this.confirmationControl = new FormGroup({
      password: new FormControl(),
      userName: new FormControl(),
      'confirm-password': new FormControl(),
    }, { validators: confirmPasswordValidator });

    this.data = this.dialogConfig.dialogData.selectedItem;
    this.isEdit = this.dialogConfig.dialogData.isEditMode;

    if (!this.isEdit){
      this.data.type = 'DEVICE';
    }

    this.dialogConfig.submitButtonDisabled = true;
  }

  ngAfterViewInit(): void {
    this.form.form.statusChanges.subscribe(() => {
      this.dialogConfig.submitButtonDisabled = !this.confirmationControl.valid;
    });
  }


}
